import React, { useState } from 'react';
import { authorizedAPI } from 'app/services/api';
import LivetickerAction from 'app/components/match/LivetickerAction';
import { captureSentryException } from 'app/services/sentryLogging';
import { formatLongDate } from 'app/helpers/dateHelpers';
import { openResultForm } from 'app/actions/softTickerActions';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'app/hooks/reduxCreateSelectorHooks';
import FuPaApiError from 'app/models/error/FuPaApiError';
const getResultCreateData = matchSlug => {
  return authorizedAPI.get("/matches/".concat(matchSlug, "/results/create"));
};
const ReportLiveResult = _ref => {
  let {
    match,
    openAuthDialog
  } = _ref;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const {
    dispatch
  } = useSoftTickerContext();
  const {
    fuPaUser
  } = useSelector(selectCurrentUser);
  const handleClick = () => {
    if (!(fuPaUser !== null && fuPaUser !== void 0 && fuPaUser.id)) {
      openAuthDialog('Erstelle ein Konto, um ganz easy den aktuellen Spielstand melden zu können.', "Ob in der Halbzeitpause oder zwischendurch: Sorg' dafür, dass alle wissen, wie's bei deiner Partie steht.", 'signup_teaser_softticker_btn');
      return;
    }
    setIsLoading(true);
    getResultCreateData(match.slug).then(handleSuccessCallback).catch(handleErrorCallback);
  };
  const handleSuccessCallback = response => {
    dispatch(openResultForm(response.data));
    setIsLoading(false);
  };
  const handleErrorCallback = error => {
    var _errorData$translated;
    const errorData = FuPaApiError.fromAxiosError(error);
    setError({
      message: (_errorData$translated = errorData.translatedMessage) !== null && _errorData$translated !== void 0 ? _errorData$translated : 'Es ist ein Fehler aufgetreten, bitte versuche es später erneut.'
    });
    setIsLoading(false);
    if ((errorData === null || errorData === void 0 ? void 0 : errorData.status) >= 400 && (errorData === null || errorData === void 0 ? void 0 : errorData.status) < 500) {
      var _match$flags;
      captureSentryException(new Error(errorData.message), {
        extra: {
          matchSlug: match === null || match === void 0 ? void 0 : match.slug,
          kickoff: formatLongDate(new Date(match === null || match === void 0 ? void 0 : match.kickoff)),
          hasTicker: match === null || match === void 0 || (_match$flags = match.flags) === null || _match$flags === void 0 ? void 0 : _match$flags.includes('ticker')
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(LivetickerAction, {
    buttonType: "secondary",
    descriptiveText: "Live-Spielstand nicht mehr aktuell? \uD83E\uDD14",
    error: error,
    isLoading: isLoading,
    label: "Live-Spielstand eintragen",
    onClick: handleClick,
    "data-sentry-element": "LivetickerAction",
    "data-sentry-component": "ReportLiveResult",
    "data-sentry-source-file": "ReportLiveResult.tsx"
  });
};
export default ReportLiveResult;